import React from 'react'
import { WorkfastLogo } from '../svg';
import { useLocation } from 'react-router-dom';
import { TbMenuDeep } from 'react-icons/tb';
import { RxCross2 } from 'react-icons/rx';

export default function Mobile() {
    const [isOpen, setIsOpen] = React.useState(false);
    const location = useLocation();

    const handleBookClick = async (e) => {
        const slotDiv = document.getElementById("slot");
        if (slotDiv) {
            slotDiv.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    };

    return (
        <div className={`${isOpen ? "fixed w-full" : "relative"} z-[60] w-full`}>
            <div className={`w-full flex justify-between items-center p-[20px] z-[50] border-[1px] border-[#CECEEA] relative ${isOpen ? "bg-[#FFF]" : ""}`}>
                <a title='Workfast' href='/'>
                    <div className='px-[10px] py-[6px] border border-[#CECEEA] rounded-[16px] bg-[#FFF]' style={{ boxShadow: '0px 4px 7px 0px #432E860A' }}>
                        <WorkfastLogo width="110" height="26" />
                    </div>
                </a>
                <div className={`flex gap-[5px] items-center ${location.pathname === "/pricingpage" || location?.pathname === "/us-price" ? "hidden" : ""}`}>
                    <div className={`flex gap-[10px] items-center`}>
                        <button className='border border-[#34C759] bg-[#34C759] rounded-[12px] px-[10px] py-[10px] md:px-[20px] w-max text-[#FFF] text-[11px] md:text-[13px] font-semibold' onClick={(e) => { handleBookClick(e) }}>Enroll for {location?.pathname === "/" ? "Surge Student" : location?.pathname === "/surge-colleges" ? "Surge College" : "Surge Speakers" }</button>
                    </div>
                    {!isOpen ?
                        <TbMenuDeep className='bg-[#FFF] text-[#24223E] w-[34px] h-[34px] p-[6px] border-[#CECEEA] border-[1px] rounded-[12px]' style={{ boxShadow: '0px 4px 7px 0px #432E860A' }} onClick={() => setIsOpen(!isOpen)} />
                        :
                        <RxCross2 className='bg-[#FFF] text-[#24223E] w-[34px] h-[34px] p-[6px] border-[#CECEEA] border-[1px] rounded-[12px]' style={{ boxShadow: '0px 4px 7px 0px #432E860A' }} onClick={() => { setIsOpen(!isOpen); }} />
                    }
                </div>
            </div>
            <div className={`${isOpen ? "max-h-full opacity-100 pb-6" : "max-h-0 opacity-0 hidden"} w-full transition-all duration-300 relative rounded-b-[20px] bg-[#FFF] z-[50]`}>
                <div className={`w-11/12 mx-auto pt-[10px]`}>
                    <div className={`py-[9px] px-[20px] w-max rounded-[10px] cursor-pointer mt-[20px] ${location?.pathname === "/" ? "text-[#B69D00] font-semibold bg-[#FFDD0933]" : "text-[#24223E]"}`} onClick={() => { window.location.href = '/'}}>
                        <p className="font-semibold text-[18px]">Surge Student</p>
                    </div>
                    <div className={`py-[9px] px-[20px] w-max rounded-[10px] cursor-pointer mt-[20px] ${location?.pathname === "/surge-colleges" ? "text-[#B69D00] font-semibold bg-[#FFDD0933]" : "text-[#24223E]"}`} onClick={(e) => { window.location.href = '/surge-colleges' }}>
                        <p className="font-semibold text-[18px]">Surge College</p>
                    </div>
                    <div className={`py-[9px] px-[20px] w-max rounded-[10px] cursor-pointer mt-[20px] ${location?.pathname === "/surge-speakers" ? "text-[#B69D00] font-semibold bg-[#FFDD0933]" : "text-[#24223E]"}`} onClick={(e) => { window.location.href = '/surge-speakers' }}>
                        <p className="font-semibold text-[18px]">Surge Speakers</p>
                    </div>
                </div>
            </div>
            {isOpen && (
                <div className='fixed h-screen w-full top-0 left-0 bg-[#000]/[90%] z-[10]' onClick={() => setIsOpen(!isOpen)}></div>
            )}
        </div>
    )
}